import { fontStyles } from 'styles/theme';
import { mobileMediaQuery } from 'utils/common';
import styled from '@emotion/styled';

export const Container = styled.div({
  margin: '80px 12%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  gap: 40,
  [mobileMediaQuery]: {
    margin: '80px 20px',
  },
});

export const SearchDescription = styled.span({
  color: fontStyles.colors.secondary,
});
